export default function button_quantity() {
  if ($('.cart .quantity').length == 0)
    return;

  $('.cart .quantity').each(function() {
    $('input[type="number"]', this).wrap('<div class="product-qty-with-buttons"></div>').before('<span class="decrease-qty-btn qty-btn">-</span>').after('<span class="increase-qty-btn qty-btn">+</span>');
    var parent = $('input[type="number"]', this).closest('.product-qty-with-buttons');

    $('.increase-qty-btn', parent).click(function() {
      $('input[type="number"]', parent).val(function(i, oldval) {
        if ($(this).attr('max') && oldval + 1 <= $(this).attr('max'))
          return ++oldval;
        else if (!$(this).attr('max'))
          return ++oldval;

        return oldval;
      });
    });

    $('.decrease-qty-btn', parent).click(function() {
      $('input[type="number"]', parent).val(function(i, oldval) {
        if ($(this).attr('min') && oldval - 1 >= $(this).attr('min'))
          --oldval;
        else if (!$(this).attr('min') && oldval - 1 > 0)
          --oldval;

        return oldval;
      });
    });
  });
}
